import React, { useEffect, useState } from 'react';
import './editprojectcontent.css';
import { getLoginId } from '../../Authentication/AuthSvc/authservice';
import { useParams } from 'react-router-dom';
import EditProjectRoles from './editprojectroles';
import EditProjectMembers from './editprojectmembers';
import EditAddProjectRoles from './editaddprojectroles';
import EditAddProjectMember from './editaddprojectmember';
import EditDeleteProject from './editdeleteproject';
import SkillsDropdown from '../../SkillsDropdown/skillsdropdown';

const API_URL = process.env.REACT_APP_API_URL;

const EditProjectContent = () => {
    const loginid = getLoginId();
    const { id } = useParams();
    const [editaddselection, setEditAddSelection] = useState('roles');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [deletePopupOpen, setIsDeletePopupOpen] = useState(false);
    const [projectdeleted, setProjectDeleted] = useState(false);
    const [project_details, setProject_Details] = useState([]);
    const [projecttaggings, setProjectTaggings] = useState([]);
    const [projectroles, setProjectRoles] = useState([]);
    const [projectmembers, setProjectMembers] = useState([]);
    const [pendingInvitations, setPendingInvitations] = useState([]);
    const [projectsave, setProjectSave] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [projectOwner, setProjectOwner] = useState(null);

    const openPopup = () => {
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };

    const openDelPopup = () => {
        setIsDeletePopupOpen(true);
    };

    const closeDelPopup = () => {
        setIsDeletePopupOpen(false);
    };

    const toggleProjectSave = () => {
        setProjectSave(true);
        setTimeout(() => {
            setProjectSave(false);
        }, 3000);
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        setSelectedFile(file);
        const reader = new FileReader();
        reader.onload = async () => {
            setPreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleFileUpload = async () => {
        if (!selectedFile) return;
        setIsUploading(true);
        const formData = new FormData();
        formData.append('image', selectedFile);
        try {
            const response = await fetch(`${API_URL}/projimageupload/${id}`, {
                method: 'POST',
                body: formData,
            });
            if (!response.ok) {
                throw new Error('Failed to upload image');
            }
            fetchProject();
        } catch (error) {
            console.log('Error uploading image', error);
        } finally {
            setIsUploading(false);
        }
    };

    const fetchProject = async () => {
        if (!id) return;
        setLoading(true);
        try {
            // Get the project details from the editproject endpoint
            const response = await fetch(`${API_URL}/editproject/${id}`);
            const data = await response.json();
            setProject_Details(data.project_details);
            setProjectTaggings(data.project_tags ? data.project_tags.split(',') : []);
            setProjectRoles(data.project_roles);
            setProjectMembers(data.project_member);
            
            console.log("Project Members:", data.project_member);
            console.log("Login ID:", loginid);
            
            // Find the project owner by looking for a member with role "Owner"
            // or check if the current user is a member of the project
            let isOwner = false;
            if (data.project_member && data.project_member.length > 0) {
                // Check if the current user is the owner
                const currentUserMember = data.project_member.find(
                    member => String(member.user_id) === String(loginid) && member.role === "Owner"
                );
                
                if (currentUserMember) {
                    isOwner = true;
                    setProjectOwner(loginid);
                } else {
                    // If not the owner, find who is the owner
                    const ownerMember = data.project_member.find(member => member.role === "Owner");
                    if (ownerMember) {
                        setProjectOwner(ownerMember.user_id);
                    }
                }
            }
            
            console.log("Is Owner:", isOwner);
        } catch (error) {
            console.error('Error fetching project', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchPendingInvitations = async () => {
        try {
            const response = await fetch(`${API_URL}/project/${id}/invitations`);
            if (!response.ok) throw new Error("Failed to fetch invitations");
            const data = await response.json();
            setPendingInvitations(data);
        } catch (error) {
            console.error("Error fetching invitations:", error);
        }
    };

    const handleEditAddSelection = (selection) => {
        setEditAddSelection(selection);
    };

    const handleAddMember = async (event) => {
        event.preventDefault();
        const memberusername = event.target.memberusername.value;
        const memberrole = event.target.memberrole.value;
        
        try {
            const response = await fetch(`${API_URL}/project/${id}/invite`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ 
                    memberUsername: memberusername, 
                    memberRole: memberrole,
                    invitedBy: loginid
                })
            });
    
            const data = await response.json();
    
            if (response.ok) {
                alert("Invitation sent successfully!");
                closePopup();
                fetchPendingInvitations();
            } else {
                switch (response.status) {
                    case 404:
                        alert("User not found. Please check the username and try again.");
                        break;
                    case 400:
                        alert(data.error); // Will show specific messages like "Already a member" or "Invitation pending"
                        break;
                    case 500:
                        alert("Server error. Please try again later.");
                        break;
                    default:
                        alert(data.error || "Failed to send invitation");
                }
            }
        } catch (error) {
            console.error("Error sending invitation:", error);
            alert("Failed to send invitation. Please check your connection and try again.");
        }
    };

    const handleCancelInvitation = async (invitationId) => {
        try {
            const response = await fetch(`${API_URL}/invitation/${invitationId}`, {
                method: 'DELETE'
            });
            
            if (response.ok) {
                fetchPendingInvitations();
            } else {
                throw new Error("Failed to cancel invitation");
            }
        } catch (error) {
            console.error("Error cancelling invitation:", error);
            alert("Failed to cancel invitation. Please try again.");
        }
    };

    const handleAddTags = async (event) => {
        event.preventDefault();
        const tagname = event.target.projtags.value;
        try {
            const response = await fetch(`${API_URL}/editproject/${id}/addtag`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ tagname: tagname })
            });
            if (response.ok) {
                event.target.projtags.value = '';
                fetchProject();
            } else {
                throw new Error("Failed to add tag");
            }
        } catch (error) {
            console.error("Error adding tag", error);
        }
    };

    const handleDeleteTag = async (tagname) => {
        try {
            const response = await fetch(`${API_URL}/editproject/${id}/deletetag`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ tagname: tagname })
            });
            if (response.ok) {
                fetchProject();
            } else {
                throw new Error("Failed to delete tag");
            }
        } catch (error) {
            console.error("Error deleting tag", error);
        }
    };

    const handleAddRole = async (event) => {
        event.preventDefault();
        const roleName = event.target.roleName.value;
        const roleDesc = event.target.roleDesc.value;

        try {
            const response = await fetch(`${API_URL}/editproject/${id}/addrole`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ roleName: roleName, roleDesc: roleDesc })
            });
            if (response.ok) {
                closePopup();
                fetchProject();
            } else {
                throw new Error("Failed to add role");
            }
        } catch (error) {
            console.error("Error adding role:", error);
        }
    };

    const handleDeleteRole = async (roleID) => {
        try {
            const response = await fetch(`${API_URL}/editproject/${id}/deleterole`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ roleID: roleID })
            });
            if (response.ok) {
                fetchProject();
            } else {
                throw new Error("Failed to delete role");
            }
        } catch (error) {
            console.error("Error deleting role:", error);
        }
    };

    const handleDeleteMember = async (memberID) => {
        try {
            const response = await fetch(`${API_URL}/editproject/${id}/deletemember`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ memberID: memberID })
            });
            if (response.ok) {
                fetchProject();
            } else {
                throw new Error("Failed to delete Project Member");
            }
        } catch (error) {
            console.error("Error deleting member:", error);
        }
    };

    const handleSubmitUpdate = async (event) => {
        event.preventDefault();
        const projtitle = event.target.projtitle.value;
        const phase = event.target.phase.value;
        const recruiting = event.target.recruiting.value;

        const projdesc = event.target.projdesc.value;
        
        const recruitbool = recruiting === 'Open';
    
        try {
            const response = await fetch(`${API_URL}/editproject/${id}/updateproject`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ projtitle, phase, recruitbool, projdesc })
            });
            if (response.ok) {
                toggleProjectSave();
                fetchProject();
            } else {
                throw new Error("Failed to update project");
            }
        } catch (error) {
            console.error("Error updating project:", error);
        }
    };

    useEffect(() => {
        fetchProject();
        fetchPendingInvitations();
    }, [id]);

    return (
        <div className='editprojectbody'>
            {loading ? (
                <p>Loading ...</p>
            ) : String(loginid) === String(projectOwner) ? (
                <div className="editproject-grid-container">
                    <div className="editproject-column1">
                    <div className="editproject-grid-item editproject-grid-1">
                        <form onSubmit={handleSubmitUpdate}>
                            <div className='titlecreate'>
                                <h2>Edit Project</h2>
                                <div>
                                    <div className='saveproject'>
                                        <button type="button" className='editprojdeleteBtn' onClick={openDelPopup}>Delete</button>
                                        {deletePopupOpen && <EditDeleteProject onClose={closeDelPopup} id={id} setProjectDeleted={setProjectDeleted} />}
                                        <button type="submit" className='editprojsaveBtn' value='send'>Update</button>
                                        {projectsave && (
                                            <span style={{ color: '#09CE78', marginLeft: '1rem' }}>Updated</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <hr style={{ marginTop: '0.8rem', marginBottom: '1rem' }} />
                            {/* Add mobile image upload here */}
                            <div className="editproject-grid-item mobile-image-upload">
                                <div className="image-upload-container">
                                    <h3>Project Image</h3>
                                    <div className="image-preview-container">
                                        <img 
                                            src={previewUrl || project_details.image} 
                                            alt="Project" 
                                            className='editprojectImg'
                                        />
                                    </div>
                                    <div className="file-input-wrapper">
                                        <input 
                                            type="file" 
                                            onChange={handleFileChange} 
                                            disabled={isUploading}
                                            className="file-input"
                                            accept="image/*"
                                        />
                                        <button 
                                            onClick={handleFileUpload} 
                                            className="uploadprojimgBtn" 
                                            disabled={isUploading}
                                        >
                                            {isUploading ? 'Uploading...' : 'Upload Image'}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div>
                            <div style={{ width: '100%' }}>
                                <input 
                                    type="text" 
                                    name="projtitle" 
                                    className='projtitleinput' 
                                    placeholder='Project Title' 
                                    defaultValue={project_details.title} 
                                    required 
                                />
                                <select 
                                    name="phase" 
                                    id="phase" 
                                    className='projdropinput' 
                                    value={project_details.phase || ''} 
                                    onChange={(e) => setProject_Details(prev => ({...prev, phase: e.target.value}))} 
                                    required
                                >
                                    <option value="" disabled hidden>Phase</option>
                                    <option value="Onboarding">Onboarding</option>
                                    <option value="Initiation">Initiation</option>
                                    <option value="Execution">Execution</option>
                                    <option value="Closed">Closed</option>
                                </select>

                                <select 
                                    name="recruiting" 
                                    id="recruiting" 
                                    className='projdropinput' 
                                    defaultValue={project_details.recruiting ? 'Open' : 'Closed'} 
                                    required
                                >
                                    <option value="Open">Open</option>
                                    <option value="Closed">Closed</option>
                                </select>
                            </div>                            
                            </div><br />
                            <div className='editprojdesc'>
                                <textarea name='projdesc' className='projdesctextarea' placeholder='Project Description' defaultValue={project_details.details} required />
                            </div><br />
                            <br />
                        </form>
                    </div>

                    <div className="editproject-grid-item editproject-grid-2">
                        <div className='editproject-nav'>

                            <div className='editproject-navitems'>
                                <button className={`editprojselbtn ${editaddselection === 'roles' ? 'editaddactive' : 'editaddinactive'}`} onClick={() => handleEditAddSelection('roles')}><span style={{ marginRight: '1.5rem', fontWeight: '390' }}>Roles</span></button>
                                <button className={`editprojselbtn ${editaddselection === 'projmembers' ? 'editaddactive' : 'editaddinactive'}`} onClick={() => handleEditAddSelection('projmembers')}><span style={{ fontWeight: '390' }}>Project Members</span></button>
                            </div>

                            <div className='editproject-navfilter'>
                                <button className='editaddbtn' onClick={openPopup}><i class="fa-solid fa-plus"></i></button>
                                {isPopupOpen && editaddselection === 'roles' && <EditAddProjectRoles onClose={closePopup} handleAddRole={handleAddRole} />}
                                {isPopupOpen && editaddselection === 'projmembers' && <EditAddProjectMember onClose={closePopup} handleAddMember={handleAddMember} />}
                            </div>
                        </div>
                        <hr />

                        {editaddselection === 'roles' && (
                            <EditProjectRoles projectroles={projectroles} handleDeleteRole={handleDeleteRole} />
                        )}
                        {editaddselection === 'projmembers' && (
                            <EditProjectMembers 
                                projectmembers={projectmembers} 
                                pendingInvitations={pendingInvitations}
                                handleDeleteMember={handleDeleteMember}
                                handleCancelInvitation={handleCancelInvitation}
                            />
                        )}

                    </div>
                </div>

                <div className="editproject-column2">

                    <div className="editproject-grid-item2 editproject-grid-3">
                        <div>
                            <img src={project_details.image} alt="Profile" className='editprojectImg' />
                        </div>
                        <div>
                            <input type="file" onChange={handleFileChange} disabled={isUploading} style={{ paddingTop: '0.2rem', width: '100%', marginBottom: '0.5rem' }} />
                            <br />
                            <button onClick={handleFileUpload} className="uploadprojimgBtn" disabled={isUploading}>Upload Image</button>
                        </div>
                    </div>

                    <div className="editproject-grid-item editproject-grid-5">
                        <h3>Project Tags</h3><br />
                        <div>
                        <form onSubmit={handleAddTags}>
                                <SkillsDropdown 
                                    onSelect={(skillName) => {
                                        handleAddTags({
                                            preventDefault: () => {},
                                            target: { projtags: { value: skillName } }
                                        });
                                    }}
                                    placeholder="Add Tag"
                                />
                            </form>
                            <div>
                                <div className='sprojtags'>
                                    {projecttaggings.length > 0 ? (
                                        projecttaggings.map((tag, index) => (
                                            <div className='sprojtags' key={index}>
                                                <span className='sprojtag'>{tag.trim()}
                                                    <button className='tagdelete' onClick={() => handleDeleteTag(tag.trim())}><i class="fa-solid fa-xmark"></i></button>
                                                </span>
                                            </div>
                                        ))
                                    ) : (
                                        <div>
                                            <span>No Tags are added.</span>
                                        </div>
                                    )}
                                    { }
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            ) : (
                <div className="deny-grid-container">
                    <div className="denycontainer">
                        <div className="denytitle">
                            <h2 style={{ fontWeight: '400', textAlign: 'center', marginBottom: '1rem' }}>Unauthorised Access.</h2>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EditProjectContent;
